import { api } from '@/redux/api/api';
import { selectOrganisationById } from '@/redux/api/seletors/select-organisation-by-id';
import { selectRoleById } from '@/redux/api/seletors/select-role-by-id';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { OptimisticItem } from '@/redux/types/optimistic-item';
import { addItemRecipe } from '@/redux/utils/add-item-recipe';
import { createOptimisticItem } from '@/redux/utils/create-optimistic-item';
import { ApplicationUser } from '@/types/application-user';
import { CreateUserQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchCreateUser: DispatchOptimisticPatchHandler<
  CreateUserQueryArg,
  { optimisticUser: OptimisticItem<ApplicationUser> }
> = (queryArg, { dispatch, getState }) => {
  const role = selectRoleById(queryArg.roleId)(getState());
  const organisation = queryArg.organisationId
    ? selectOrganisationById(queryArg.organisationId)(getState())
    : undefined;
  const optimisticUser = createOptimisticItem<ApplicationUser>({
    id: -1,
    firstName: queryArg.firstName,
    lastName: queryArg.lastName,
    email: queryArg.email,
    role,
    organisation,
  });

  const patch = dispatch(
    api.util.updateQueryData(
      'getUsers',
      undefined,
      addItemRecipe<ApplicationUser>(optimisticUser),
    ),
  );

  return { patch, optimisticUser };
};
